import React from 'react'
import { Helmet } from 'react-helmet'
import Breadcrumb from '../components/Breadcrumb'
import FaqAccordion from "../components/TermsAcordian";

const Terms = () => {
    const termsData = [
        { 
          question: "Payment Policy and Fees", 
          answer: "- All payments made to Om Softwares are final and non-refundable.\n- Work will commence only after receipt of the agreed advance payment.\n- Any pending payments shall incur a late fee interest of 10% per month on the outstanding balance." 
        },
        { 
          question: "Service Commencement, Cancellation, and Pausing", 
          answer: "- Service period begins upon confirmation of the advance payment.\n- Clients must provide a minimum of 7 days’ notice prior to the next billing cycle to pause or cancel services.\n- Om Softwares reserves the right to suspend services immediately if proper notice is not provided." 
        },
        { 
          question: "Advertising Spend and Related Charges", 
          answer: "- Advertising expenditures are separate from management fees and must be paid directly to the respective advertising platforms.\n- The Client is solely responsible for maintaining sufficient funds and complying with all advertising platform policies." 
        },
        { 
          question: "Intellectual Property Rights and All Rights Reserved", 
          answer: "- All creative work, designs, strategies, content, and deliverables developed by Om Softwares remain the exclusive property of Om Softwares.\n- Clients are granted only a limited, non-transferable license to use such deliverables solely for their intended purpose." 
        },
        { 
          question: "Confidentiality and Data Protection", 
          answer: "- Both parties shall maintain the confidentiality of proprietary information exchanged.\n- Om Softwares employs industry-standard security measures to protect confidential data, but is not liable for breaches due to unauthorized access." 
        },
        { 
          question: "Data Privacy and Cookies Policy", 
          answer: "- Om Softwares may collect personal information for providing and improving our services, in strict accordance with applicable data privacy laws.\n- Our website uses cookies to enhance user experience.\n- Data may be shared with select third-party companies as necessary, subject to confidentiality agreements." 
        },
        { 
          question: "Limitation of Liability", 
          answer: "- Om Softwares' liability is strictly limited to the fees paid by the Client for the services rendered.\n- Under no circumstances shall Om Softwares be liable for any indirect, incidental, or consequential damages." 
        },
        { 
          question: "Indemnification", 
          answer: "- The Client agrees to indemnify and hold harmless Om Softwares from any claims, damages, or liabilities arising from the Client's use of our services, breach of these terms, or violation of any applicable laws." 
        },
        { 
          question: "Amendments and Modifications", 
          answer: "- Om Softwares reserves the sole right to modify these Terms and Conditions at any time.\n- Clients will be informed of material changes, and continued use of our services constitutes acceptance of the revised terms." 
        },
        { 
          question: "Force Majeure", 
          answer: "- Om Softwares shall not be liable for delays or failures in performance due to causes beyond its control, such as natural disasters, governmental actions, or other unforeseen events." 
        },
        { 
          question: "Governing Law and Dispute Resolution", 
          answer: "- This Agreement is governed by the laws of Nangal/Anandpur Sahib.\n- Any disputes arising from this Agreement shall be exclusively resolved in the courts of this jurisdiction." 
        },
        { 
          question: "Entire Agreement and Severability", 
          answer: "- This Agreement constitutes the entire understanding between the Client and Om Softwares, superseding all prior agreements.\n- If any provision is found invalid, the remaining provisions shall continue in effect." 
        },
        { 
          question: "Non-Waiver", 
          answer: "- Failure by Om Softwares to enforce any provision of this Agreement shall not be deemed a waiver of its right to enforce such provision in the future." 
        },
        { 
          question: "Right to Terminate", 
          answer: "- Om Softwares reserves the right to suspend or terminate services immediately and without notice if the Client breaches any provision of this Agreement or engages in conduct detrimental to Om Softwares' interests." 
        },
        {
          question: "Internship Payment Conditions",
          answer: "- If an intern fails to complete the full tenure of the internship, they will not be eligible for any partial payments or benefits. For example, if the internship is for 3 months (90 working days) and a lump sum of ₹9000 is promised, the full amount will only be paid after successful completion of the full tenure."
        },
        {
          question: "Design Credit Policy for Graphic Interns",
          answer: "- For graphic-related internships, the stipend structure may involve design credits. These credits will be assigned and evaluated by your team lead. The decision of the team lead regarding the number of credits assigned is final and cannot be contested."
        },
        {
          question: "Unpaid Credits in Stipend Justification",
          answer: "- Some design credits may be considered unpaid and are required to justify the fixed stipend or salary structure. Only after meeting the base expectation of unpaid credits, additional credits will be considered for extra payment as per the offer letter."
        },
        {
          question: "Design Credit Payment Structure",
          answer: "- If your internship or offer letter includes a design credit-based payment system, you will only be eligible for payment after completing the minimum required number of design credits. For example, if your offer letter states that you will be paid ₹200 per design credit after achieving 100 credits in a month, then you must complete at least 300 design credits over 3 months (or 100 credits per month) to qualify for payment. The per-credit amount and minimum threshold may vary and will be specifically mentioned in your offer letter. The example mentioned here is for explanation purposes only and not a fixed amount."
        },
        {
          question: "Final Decision Authority",
          answer: "- All decisions regarding internship credits, evaluations, and eligibility for payments are at the sole discretion of Om Softwares' team leads or management. Their decision will be considered final in all cases."
        },
        {
          question: "Resignation Notice Period",
          answer: "- Interns and employees are required to provide at least 15 days' prior written notice before leaving Om Softwares. Failure to provide notice may result in forfeiture of any pending payments, certificates, or experience letters."
        },
        {
          question: "Unauthorized Absence",
          answer: "- If an intern or employee is absent without approval for more than 3 consecutive working days, it may be treated as voluntary abandonment of the role, and Om Softwares reserves the right to terminate the engagement without further notice."
        },
        {
          question: "Exit Formalities",
          answer: "- Interns and employees must complete all pending work, handovers, and formal exit procedures to be eligible for any final payments, certificates, or relieving letters."
        },
        {
          question: "Confidentiality and Non-Disclosure",
          answer: "- Interns and employees must not share, distribute, or use any internal data, client information, or proprietary material outside of Om Softwares. Breach of this condition may lead to immediate termination and legal action."
        },
        {
          question: "Ownership of Work",
          answer: "- All work, designs, code, or documents created during the tenure of the internship or employment are the intellectual property of Om Softwares and cannot be reused or claimed personally unless explicitly permitted in writing."
        },
        {
          question: "Work Hours and Attendance",
          answer: "- Interns and employees are expected to adhere to the assigned work schedule. Frequent absenteeism or lack of attendance may impact payments, project allocations, or continuation of internship/employment."
        },
        {
          question: "Performance Evaluation",
          answer: "- Continuation and completion of internship/employment is subject to satisfactory performance. Om Softwares reserves the right to terminate the engagement if expectations are not met, with or without notice."
        },
        {
          question: "Experience Certificate Eligibility",
          answer: "- Certificates or experience letters will only be issued upon successful completion of the full agreed tenure and all assigned tasks. No certificate will be issued for partial or early exits unless approved in writing."
        },
        {
          question: "Stipend or Salary Delays",
          answer: "- While Om Softwares strives to release payments on time, any delays due to performance review, verification, or administrative issues shall not be treated as breach of agreement."
        }
                
      ];
      
  return (
    <>
    <Helmet>
      <title>Terms & Conditions - Om Softwares</title>
      <meta name="description" content="Read Om Softwares' terms and conditions covering payment policy, intellectual property, data privacy, service agreements, and internship policies." />
      <meta property="og:title" content="Terms & Conditions - Om Softwares" />
      <meta property="og:description" content="Terms and conditions for Om Softwares' services, internships, and policies." />
      <meta property="og:image" content="https://omsoftwares.in/assets/img/seo/ogImage.png" />
      <meta property="og:url" content="https://omsoftwares.in/terms" />
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="Terms & Conditions - Om Softwares" />
      <meta name="twitter:description" content="Terms and conditions for Om Softwares' services, internships, and policies." />
      <meta name="twitter:image" content="https://omsoftwares.in/assets/img/seo/ogImage.png" />
    </Helmet>
    <Breadcrumb name="Terms & Conditions"/>
    <FaqAccordion faqData={termsData} />
    </>
  )
}

export default Terms
